/* =====================================================
   FTF: Product Image Lightbox — click to view full image
   ===================================================== */
(function () {
  function initFTFLightbox() {
    // Build overlay if not already present
    if (document.getElementById('ftf-lightbox-overlay')) return;

    const overlay = document.createElement('div');
    overlay.id = 'ftf-lightbox-overlay';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-label', 'Product image lightbox');
    overlay.innerHTML = `
      <button id="ftf-lightbox-close" aria-label="Close lightbox">&#x2715;</button>
      <button id="ftf-lightbox-prev" aria-label="Previous image">&#8592;</button>
      <img id="ftf-lightbox-img" src="" alt="" />
      <button id="ftf-lightbox-next" aria-label="Next image">&#8594;</button>
      <span id="ftf-lightbox-counter"></span>
    `;
    document.body.appendChild(overlay);

    let currentIndex = 0;
    let triggers = [];

    function getTriggersInSection() {
      // Collect all visible (non-variant-hidden) triggers in the active product gallery
      return Array.from(
        document.querySelectorAll(
          '.product__media-list .product__media-item:not(.product__media-item--variant) .ftf-lightbox-trigger, ' +
          '.product__media-list .product__media-item.is-active .ftf-lightbox-trigger'
        )
      ).filter(el => {
        // Only include triggers that are actually in the DOM and visible
        return el.offsetParent !== null || el.closest('.product__media-item');
      });
    }

    function getAllTriggers() {
      return Array.from(document.querySelectorAll('.ftf-lightbox-trigger'));
    }

    function openLightbox(trigger) {
      triggers = getAllTriggers();
      currentIndex = triggers.indexOf(trigger);
      showImage(currentIndex);
      overlay.classList.add('ftf-lb-open');
      document.body.style.overflow = 'hidden';
      document.getElementById('ftf-lightbox-close').focus();
    }

    function closeLightbox() {
      overlay.classList.remove('ftf-lb-open');
      document.body.style.overflow = '';
    }

    function showImage(index) {
      const trigger = triggers[index];
      if (!trigger) return;
      const img = document.getElementById('ftf-lightbox-img');
      const fullUrl = trigger.getAttribute('data-full-img');
      const alt = trigger.getAttribute('data-alt') || '';
      img.src = fullUrl;
      img.alt = alt;
      const counter = document.getElementById('ftf-lightbox-counter');
      counter.textContent = triggers.length > 1 ? `${index + 1} / ${triggers.length}` : '';
      // Show/hide nav arrows
      document.getElementById('ftf-lightbox-prev').style.display = triggers.length > 1 ? '' : 'none';
      document.getElementById('ftf-lightbox-next').style.display = triggers.length > 1 ? '' : 'none';
    }

    // Delegate click on triggers
    document.addEventListener('click', function (e) {
      const trigger = e.target.closest('.ftf-lightbox-trigger');
      if (trigger) {
        e.preventDefault();
        openLightbox(trigger);
        return;
      }
    });

    // Keyboard: Enter / Space on focused trigger
    document.addEventListener('keydown', function (e) {
      if ((e.key === 'Enter' || e.key === ' ') && e.target.classList.contains('ftf-lightbox-trigger')) {
        e.preventDefault();
        openLightbox(e.target);
      }
    });

    // Close button
    document.getElementById('ftf-lightbox-close').addEventListener('click', closeLightbox);

    // Click overlay background to close
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) closeLightbox();
    });

    // Prev / Next
    document.getElementById('ftf-lightbox-prev').addEventListener('click', function (e) {
      e.stopPropagation();
      currentIndex = (currentIndex - 1 + triggers.length) % triggers.length;
      showImage(currentIndex);
    });
    document.getElementById('ftf-lightbox-next').addEventListener('click', function (e) {
      e.stopPropagation();
      currentIndex = (currentIndex + 1) % triggers.length;
      showImage(currentIndex);
    });

    // Keyboard navigation when open
    document.addEventListener('keydown', function (e) {
      if (!overlay.classList.contains('ftf-lb-open')) return;
      if (e.key === 'Escape') closeLightbox();
      if (e.key === 'ArrowLeft') {
        currentIndex = (currentIndex - 1 + triggers.length) % triggers.length;
        showImage(currentIndex);
      }
      if (e.key === 'ArrowRight') {
        currentIndex = (currentIndex + 1) % triggers.length;
        showImage(currentIndex);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFTFLightbox);
  } else {
    initFTFLightbox();
  }
})();

/* ===================================================== */

if (!customElements.get('product-modal')) {
  customElements.define('product-modal', class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  });
}
